import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.rotator = this.el;
        this.rotatorItems = this.rotator.querySelectorAll('.about-missions_titles_item');
        this.rotatorIndex = 0;
        this.rotatorPrevIndex = null;

        document.fonts.ready.then(() => {
            this.rotatorTL = gsap.timeline({ repeatDelay: 4, repeat: -1, });
            this.rotatorTL.call(() => { this.updateRotator(); });
        });
    }

    init() {
    }

    updateRotator() {
        let item = this.rotatorItems[this.rotatorIndex];

        if (this.rotatorPrevIndex != null) {
            gsap.to(
                this.rotatorItems[this.rotatorPrevIndex].querySelectorAll('.word'),
                { y: '-101%', duration: 0.6, ease: 'power4.out', stagger: 0.02 },
            );
        }
        
        gsap.fromTo(
            item.querySelectorAll('.word'),
            { y: '101%' },
            { y: '0%', duration: 0.8, ease: 'power4.out', stagger: 0.05, delay: 0.4, onComplete: () => {
                this.rotatorPrevIndex = this.rotatorIndex;
                this.rotatorIndex = (this.rotatorIndex == this.rotatorItems.length - 1) ? 0 : this.rotatorIndex + 1;
            } },
        );
    }
}
